import axios from 'axios'

const API_URL: string = process.env.REACT_APP_API_URL as string

const REQUEST_EXPORT_REPORT_DEVICES_URL = `${API_URL}/report-export/export-devices`
const REQUEST_EXPORT_REPORT_USER_USAGE_URL = `${API_URL}/report-export/export-user-usage`
const REQUEST_EXPORT_REPORT_INTENTS_URL = `${API_URL}/report-export/export-intents`
const REQUEST_EXPORT_REPORT_FALSE_MESSAGE_URL = `${API_URL}/report-export/export-false-message`
const REQUEST_EXPORT_REPORT_ACCESS_LOG_URL = `${API_URL}/report-export/export-access-log`

const REQUEST_REPORT_DEVICES_URL = `${API_URL}/report/devices`
const REQUEST_REPORT_USER_USAGE_URL = `${API_URL}/report/user-usage`
const REQUEST_REPORT_INTENT_URL = `${API_URL}/report/intents`
const REQUEST_REPORT_FALSE_MESSAGE_URL = `${API_URL}/report/false-message`
const REQUEST_REPORT_ACCESS_LOG_URL = `${API_URL}/report/access-log`

export function getExportReportDevices(params:any={}) {

  const qs = Object.keys(params)
    .filter(key=>params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&');

  return REQUEST_EXPORT_REPORT_DEVICES_URL + `?${qs}`
}

export function getExportReportUserUsage(params:any={}) {

  const qs = Object.keys(params)
    .filter(key=>params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&');

  return REQUEST_EXPORT_REPORT_USER_USAGE_URL + `?${qs}`
}

export function getExportReportIntents(params:any={}) {

  const qs = Object.keys(params)
    .filter(key=>params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&');

  return REQUEST_EXPORT_REPORT_INTENTS_URL + `?${qs}`
}

export function getExportReportFalseMessage(params:any={}) {

  const qs = Object.keys(params)
    .filter(key=>params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&');

  return REQUEST_EXPORT_REPORT_FALSE_MESSAGE_URL + `?${qs}`
}

export function getExportReportAccessLog(params:any={}) {

  const qs = Object.keys(params)
    .filter(key=>params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&');

  return REQUEST_EXPORT_REPORT_ACCESS_LOG_URL + `?${qs}`
}

export function getReportDevices(params:any) {
  return axios.get<any>(REQUEST_REPORT_DEVICES_URL, {
    params:params
  })
}

export function getReportUserUsage(params:any={}) {
  return axios.get<any>(REQUEST_REPORT_USER_USAGE_URL, {
    params:params
  })
}

export function getReportIntent(params:any={}) {
  return axios.get<any>(REQUEST_REPORT_INTENT_URL, {
    params:params
  })
}

export function getReportFalseMessage(params:any={}) {
  return axios.get<any>(REQUEST_REPORT_FALSE_MESSAGE_URL, {
    params:params
  })
}

export function getReportAccessLog(params:any={}) {
  return axios.get<any>(REQUEST_REPORT_ACCESS_LOG_URL, {
    params:params
  })
}
